import axios from "axios";
import { APIGATEWAY } from '../main_config';
import { getDeviceId, getBrowser } from '../utils';

export const requestLoginApiManager = async (tipoDoc, nroDoc, password ) => {
    return axios({
        baseURL: APIGATEWAY.URL,
        url: '/cl/api-smg/v0/auth-login',
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
        },
        data: {
          apiKey: APIGATEWAY.APIKEY,
          tipoDoc: tipoDoc,
          nroDoc: nroDoc,
          password: password,
          device: {
            messagingid : "----",
            deviceid: getDeviceId(),
            devicename: getBrowser(),
            bloqueado: 1,
            recordar: 0,
          }
        },
        timeout:15000,
      })
    }